import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPhoneNumber'
})

export class FormatPhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const phoneRegex = /^(\d{2})(\d{4,5})(\d{4})$/;
    const match = value.match(phoneRegex);

    if (!match) return value;

    return `(${match[1]}) ${match[2]}${match[3]}`;
  }
}